import { ObjectType } from 'modules/common/utils/types';
import { MarketplaceAPI } from 'revibe-api';

export const getSizeLabelFromSize = (
  size: string,
  category: MarketplaceAPI.Category
) => {
  if (!category || category.slug !== 'shoes') {
    return size;
  }
  switch (size) {
    case 'xxs':
      return '35';
    case 'xs':
      return '36';
    case 's':
      return '37';
    case 'm':
      return '38';
    case 'l':
      return '39';
    case 'xl':
      return '40';
    case 'xxl':
      return '41';
    case '3xl':
      return '42';
    case '4xl':
      return '43';
    case '5xl':
      return '44';
    case '6xl':
      return '45';
    case '7xl':
      return '46';
    case '8xl':
      return '47';
    default:
      return 'unisize';
  }
};

export const getAvailableSizes = (item: MarketplaceAPI.Item) => {
  if (item.stock.unisize !== 0) {
    return [
      {
        id: 'unisize',
        label: 'unisize',
      },
    ] as { id: MarketplaceAPI.ItemSize; label: string }[];
  }

  const availableSizes: { id: MarketplaceAPI.ItemSize; label: string }[] = [];

  for (const s in item.stock) {
    const sizeAmount = (item.stock as ObjectType<number>)[s];
    if (sizeAmount > 0 || (item.available_for_preorder && sizeAmount < 0)) {
      availableSizes.push({
        id: s as MarketplaceAPI.ItemSize,
        label: getSizeLabelFromSize(s, item.category),
      });
    }
  }

  return availableSizes;
};
